<template>
  <div class="container gap-32 scroll-container">
    <router-link to="/"/>
    <HeaderTitle :titleName="'Cadastro'" :isVisibleHeaderTitle="showHeader"/>
    <router-view/>
  </div>
</template>

<script >
  import HeaderTitle from './components/HeaderTitle.vue'
  import { useStore } from '../stores/cadastro.js'
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  export default {
     components: {
      HeaderTitle
    },
    setup() {
      const store = useStore();
      const preRegistrationData = store.getRegistrationData
      const route = useRoute();

      const hideHeaderRoutes = [

      '/dados-do-veiculo/preview-imagem-veiculo',
      '/dados-do-veiculo/frente-do-veiculo',
      '/dados-do-veiculo/traseira-do-veiculo',
      '/dados-do-veiculo/bau-do-veiculo',
      '/dados-do-veiculo/lateral-do-veiculo',
      '/dados-pessoais/comprovante-de-residencia',
      '/dados-pessoais/preview-comprovante-de-residencia',
      '/documentacoes/preview-imagem-documentacoes',
      '/documentacoes/cnh',
      '/documentacoes/selfie-cnh',
      '/documentacoes/crlv',
      '/documentacoes/renavam',
      '/final/termos-de-uso',
      '/final/aviso'
      ];
      const showHeader = computed(() => !hideHeaderRoutes.includes(route.path));

        return {
          preRegistrationData,
          showHeader
        };
    }
  }
</script>
